// extracted by mini-css-extract-plugin
export default {"Container":"Landing_Container__+WqJV","Header":"Landing_Header__vV2wb","Img":"Landing_Img__o-Dfh","p":"Landing_p__YvQZr","h2":"Landing_h2__ynC8Q"};